/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "रद्द करें"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "आपके पास कस्टमर डेटा तक पहुँचने के लिए बिज़नेस से जुड़ा उद्देश्य है"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "सुरक्षा अनुपालन उद्देश्यों के लिए आपकी डाउनलोड गतिविधि को रिकॉर्ड और ट्रैक किया जाएगा"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "क्या आप आगे बढ़ना चाहते हैं?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "डाउनलोड करके आप स्वीकार करते हैं कि:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
